<template>
  <li
    v-if="showMenu"
    class="department-menu members__content"
    @click="onClickMenu">
    <div class="members__content p-2">
      <p class="members__name">
        {{ department.name }}（{{ memberItemsCount }}）
      </p>
      <small
        v-if="departmentIsFollowed"
        class="text-black-50">グループ全体をフォロー中</small>
    </div>
    <transition name="list-menu">
      <div
        v-show="showMembers"
        @click.stop>
        <ul
          class="members__list list-unstyled">
          <settings-follow-department-member-list-item
            v-for="member in memberItems" 
            :key="member.id"
            :member="member" />
        </ul>
      </div>
    </transition>
  </li>
</template>

<script>
import SettingsFollowDepartmentMemberListItem from '@/components/view/SettingsFollowDepartmentMemberListItem'

export default {
  components: {
    SettingsFollowDepartmentMemberListItem
  },
  props: {
    department: {
      type: Object,
      required: true 
    },
    localMembersFollowing: {
      type: Array,
      required: true
    },
    departmentIsFollowed: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      menuTapped: false,
      departmentMembers: []
    }
  },
  computed: {
    showMembers() {
      return this.menuTapped && this.memberItems.length > 0
    },
    memberItems() {
      if (this.departmentIsFollowed) {
        return this.departmentMembers
      }
      return this.localMembersFollowing
    },
    memberItemsCount() {
      return this.memberItems.length
    },
    // フォローされていないグループor個別にフォローされているユーザーが一人もいないグループは表示しない
    showMenu() {
      return this.department && this.memberItemsCount !== 0
    }
  },  
  created() {
    this.$axios.get(`/users/?department__in=${this.department.id}&ordering=-sort_no`).then((res) => {
      this.departmentMembers = res.data.results
    })    
  },
  methods: {
    onClickMenu() {
      this.menuTapped = !this.menuTapped
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/members.scss";

.department-menu :hover{
   cursor: pointer;
}

.list-menu-enter-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.list-menu-leave-active {
  transition: all 0.1s;
}
.list-menu-enter, .list-menu-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
</style>